import React from 'react';
import onClickOutside from 'react-onclickoutside';
import { withRouter } from 'react-router-dom';
import { FaRegBell } from 'react-icons/fa';
import Moment from 'react-moment';
import { config } from 'Constants.js';

class HeaderNotifications extends React.Component {
	constructor(props) {
		super(props);
		this.authUser = window.localStorage.getItem('auth_user') == null
			? { id: null, name: null }
			: JSON.parse(window.localStorage.getItem('auth_user'));
		this.state = {
			showDrawer: false,
			notifications: [],
			projectMap: {}
		};
		this.toggleDrawer = this.toggleDrawer.bind(this);
		this.closeDrawer = this.closeDrawer.bind(this);
		this.loadData = this.loadData.bind(this);
		this.markAllSeen = this.markAllSeen.bind(this);
		this.goTo = this.goTo.bind(this);
	}

	componentDidMount() {
		if (this.authUser.id != null) {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const [projRes, notifRes] = await Promise.all([
				fetch(config.url.API_URL + 'projects', {
					method: 'POST',
					body: JSON.stringify({ user_id: this.authUser.id }),
					headers: { 'Content-Type': 'application/json' }
				}),
				fetch(config.url.API_URL + 'notifications', {
					method: 'POST',
					body: JSON.stringify({ user_id: this.authUser.id }),
					headers: { 'Content-Type': 'application/json' }
				})
			]);
			const projects = await projRes.json();
			const notifications = await notifRes.json();
			const projectMap = {};
			(projects.list || []).forEach((p) => {
				projectMap[p._id] = p;
			});
			this.setState({
				notifications: Array.isArray(notifications) ? notifications : [],
				projectMap: projectMap
			});
		} catch (e) {
			// silent fail — bell simply shows no notifications
		}
	}

	toggleDrawer(e) {
		if (e) e.stopPropagation();
		this.setState({ showDrawer: !this.state.showDrawer });
	}

	closeDrawer() {
		this.setState({ showDrawer: false });
	}

	handleClickOutside() {
		if (this.state.showDrawer) this.setState({ showDrawer: false });
	}

	async markAllSeen() {
		const imageIds = Array.from(
			new Set(
				this.state.notifications
					.map((n) => (n.image && n.image._id) || n.image_id)
					.filter(Boolean)
			)
		);
		try {
			await Promise.all(
				imageIds.map((image_id) =>
					fetch(config.url.API_URL + 'seenall', {
						method: 'POST',
						body: JSON.stringify({ image_id: image_id, user_id: this.authUser.id }),
						headers: { 'Content-Type': 'application/json' }
					})
				)
			);
		} catch (e) {
			// ignore — clear locally regardless
		}
		this.setState({ notifications: [], showDrawer: false });
	}

	renderNotifyText(n) {
		if (n.replies && n.replies.length > 0) {
			const last = n.replies[n.replies.length - 1];
			const reply = (last.reply || '').toString();
			return reply.length > 60 ? reply.substring(0, 60) + '...' : reply;
		}
		if (n.message === 'design') return 'This design was updated';
		return n.message || 'New activity';
	}

	renderNotifyTime(n) {
		if (n.replies && n.replies.length > 0) {
			return n.replies[n.replies.length - 1].created;
		}
		return n.created;
	}

	buildNotifyLink(n) {
		const imageId = (n.image && n.image._id) || n.image_id;
		const versionId = (n.version && n.version._id) || n.version_id;
		const commentId = n._id;
		if (imageId && versionId && commentId) return '/' + imageId + '/' + versionId + '?showing_comment=' + commentId;
		if (imageId && commentId) return '/' + imageId + '?showing_comment=' + commentId;
		if (imageId) return '/' + imageId;
		if (n.project) return '/p/' + n.project;
		return null;
	}

	goTo(to) {
		if (!to) return;
		this.setState({ showDrawer: false }, () => {
			this.props.history.push(to);
		});
	}

	buildGroups() {
		const groups = {};
		this.state.notifications.forEach((n) => {
			const pid = n.project || n.project_id || 'unknown';
			if (!groups[pid]) groups[pid] = [];
			groups[pid].push(n);
		});
		return groups;
	}

	render() {
		const pathname = this.props.location ? this.props.location.pathname : '';
		if (pathname !== '/' && pathname !== '/projects') return null;

		const total = this.state.notifications.length;
		const groups = this.buildGroups();
		const projectIds = Object.keys(groups);

		return (
			<li className="header-notify-bell" title="Unread messages">
				<span className="header-notify-bell-icon" onClick={this.toggleDrawer}>
					<FaRegBell />
					{total > 0 ? <span className="header-notify-count">{total}</span> : null}
				</span>
				{this.state.showDrawer ? (
					<div id="headerNotifyDrawer" className="header-notify-drawer" onClick={(e) => e.stopPropagation()}>
						<div className="header-notify-drawer-head">
							<span className="title">Unread messages</span>
							<button type="button" className="close-btn" onClick={this.closeDrawer} title="Close">&times;</button>
						</div>
						<div className="header-notify-drawer-sub">
							<span>{total} unread across {projectIds.length} project{projectIds.length === 1 ? '' : 's'}</span>
							{total > 0 ? (
								<button type="button" className="mark-all-btn" onClick={this.markAllSeen}>Mark all as seen</button>
							) : null}
						</div>
						<div className="header-notify-drawer-body">
							{total === 0 ? (
								<div className="header-notify-empty">You're all caught up.</div>
							) : (
								projectIds.map((pid) => {
									const project = this.state.projectMap[pid];
									const name = project ? project.name : 'Project';
									return (
										<div key={pid} className="header-notify-group">
											<div className="header-notify-group-head">
												<span
													className="header-notify-group-name"
													onClick={() => this.goTo('/p/' + pid)}
												>{name}</span>
												<span className="count">{groups[pid].length}</span>
											</div>
											<ul className="header-notify-list">
												{groups[pid].map((n, idx) => {
													const to = this.buildNotifyLink(n);
													return (
														<li
															key={idx}
															className={to ? 'header-notify-item clickable' : 'header-notify-item'}
															onClick={() => this.goTo(to)}
														>
															<div className="header-notify-text">{this.renderNotifyText(n)}</div>
															<Moment format="DD MMM YY hh:mma">{this.renderNotifyTime(n)}</Moment>
														</li>
													);
												})}
											</ul>
										</div>
									);
								})
							)}
						</div>
					</div>
				) : null}
			</li>
		);
	}
}

export default withRouter(onClickOutside(HeaderNotifications));
